export async function getBalance(client, params) {
    const data = await client.request({
        method: 'getBalance',
        params,
    }, { dedupe: true });
    return data;
}
//# sourceMappingURL=getBalance.js.map